import { Link } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'

export function ProTrialBanner() {
  const { user } = useAuth()
  if (!user?.proTrialActive || user.plan !== 'FREE') return null

  const days = user.proTrialDaysRemaining
  const urgent = days !== null && days <= 7
  const endLabel = user.proTrialEndsAt
    ? new Date(user.proTrialEndsAt).toLocaleDateString('el-GR')
    : null

  return (
    <div
      className={`border-b px-4 py-2.5 text-center text-sm ${
        urgent
          ? 'border-amber-200/80 bg-amber-50 text-amber-950 dark:border-amber-900/60 dark:bg-amber-950/40 dark:text-amber-100'
          : 'border-violet-200/80 bg-violet-50 text-violet-950 dark:border-violet-900/60 dark:bg-violet-950/40 dark:text-violet-100'
      }`}
      role="status"
    >
      <span className="font-medium">Δοκιμή Pro</span>
      {days !== null ? (
        <>
          {' '}
          — απομένουν {days} {days === 1 ? 'ημέρα' : 'ημέρες'}
          {endLabel ? ` (έως ${endLabel})` : ''}. Έχετε πρόσβαση σε Pro
          (ραντεβού, προφίλ, follow-up)· όχι Business αναφορές.
        </>
      ) : (
        ' — ενεργή δοκιμαστική περίοδος Pro.'
      )}{' '}
      <Link
        to="/billing"
        className="font-semibold underline underline-offset-2 hover:no-underline"
      >
        Δείτε συνδρομές
      </Link>
    </div>
  )
}
